var _regeneratorRuntime = require("/Users/dominicwhyte/dev/prodtryapis/tryapis/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/Users/dominicwhyte/dev/prodtryapis/tryapis/node_modules/@babel/runtime/helpers/slicedToArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license https://raw.githubusercontent.com/node-fetch/node-fetch/master/LICENSE.md
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 - 2020 Node Fetch Team
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * Extracted from https://github.com/node-fetch/node-fetch/blob/64c5c296a0250b852010746c76144cb9e14698d9/src/utils/form-data.js
 */
var carriage = '\r\n';
var dashes = '-'.repeat(2);
var NAME = Symbol.toStringTag;

var isBlob = function isBlob(object) {
  return typeof object === 'object' && typeof object.arrayBuffer === 'function' && typeof object.type === 'string' && typeof object.stream === 'function' && typeof object.constructor === 'function' && /^(Blob|File)$/.test(object[NAME]);
};
/**
 * @param {string} boundary
 */


var getFooter = function getFooter(boundary) {
  return "".concat(dashes).concat(boundary).concat(dashes).concat(carriage.repeat(2));
};
/**
 * @param {string} boundary
 * @param {string} name
 * @param {*} field
 *
 * @return {string}
 */


function getHeader(boundary, name, field) {
  var header = '';
  header += "".concat(dashes).concat(boundary).concat(carriage);
  header += "Content-Disposition: form-data; name=\"".concat(name, "\"");

  if (isBlob(field)) {
    header += "; filename=\"".concat(field.name, "\"").concat(carriage);
    header += "Content-Type: ".concat(field.type || 'application/octet-stream');
  }

  return "".concat(header).concat(carriage.repeat(2));
}
/**
 * @return {string}
 */


module.exports.getBoundary = function () {
  // This generates a 50 character boundary similar to those used by Firefox.
  // They are optimized for boyer-moore parsing.
  var boundary = '--------------------------';

  for (var i = 0; i < 24; i++) {
    boundary += Math.floor(Math.random() * 10).toString(16);
  }

  return boundary;
};
/**
 * @param {FormData} form
 * @param {string} boundary
 */


module.exports.formDataIterator = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(form, boundary) {
  var _iterator, _step, _step$value, name, value;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(form);
          _context.prev = 1;

          _iterator.s();

        case 3:
          if ((_step = _iterator.n()).done) {
            _context.next = 17;
            break;
          }

          _step$value = _slicedToArray(_step.value, 2), name = _step$value[0], value = _step$value[1];
          _context.next = 7;
          return getHeader(boundary, name, value);

        case 7:
          if (!isBlob(value)) {
            _context.next = 11;
            break;
          }

          return _context.delegateYield(value.stream(), "t0", 9);

        case 9:
          _context.next = 13;
          break;

        case 11:
          _context.next = 13;
          return value;

        case 13:
          _context.next = 15;
          return carriage;

        case 15:
          _context.next = 3;
          break;

        case 17:
          _context.next = 22;
          break;

        case 19:
          _context.prev = 19;
          _context.t1 = _context["catch"](1);

          _iterator.e(_context.t1);

        case 22:
          _context.prev = 22;

          _iterator.f();

          return _context.finish(22);

        case 25:
          _context.next = 27;
          return getFooter(boundary);

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[1, 19, 22, 25]]);
});
module.exports.isBlob = isBlob;